<template>
    <div class="Details">
    <section>
        <div class="x">
            <b-field v-if="!isOnboarding" :message="'You plan allow you to add up to '+getRecordsLimit() || 1000+' records from different data sources'">
                        <b>Records summary: </b>&nbsp;{{  rows.length | 0 }} / {{  getRecordsLimit() || 1000 }}
                    </b-field>
                    <b-collapse 
                        v-if="projectUploads.length"
                        :open="showFileUpload" 
                        position="is-top" 
                        aria-id="contentIdForA11y4">
                        <template #trigger="props">
                            <a
                                class="is-pulled-rightx"
                                aria-controls="contentIdForA11y4"
                                :aria-expanded="props.open">
                                <svg v-if="!props.open" xmlns="http://www.w3.org/2000/svg" height="16" width="10" viewBox="0 0 320 512"> <path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"/></svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" height="16" width="10" viewBox="0 0 320 512"> <path d="M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"/></svg>
                                {{ !props.open ? 'Show Uploads' : 'Hide Uploads' }}
                        </a>
                        </template>
                        <b-table 
                        :striped="true"
                        :narrowed="true"
                 :data="projectUploads"
                 :per-page="5"
                 :total="projectUploads.length"
                 :pagination-position="'top'"
                 :paginated="projectUploads.length > 4"
                 pagination-size="is-small"
                 >
                 <template #top-left>
                    <b-field>
                        <b>Uploaded files:</b>
                    </b-field>  
                  </template>
                  
                  <b-table-column cellClass="has-text-left" width="90" field="Upload" v-slot="props">
                    <b-tag type="is-primary" size="is-smallx">{{ props.row.fileFormat.toUpperCase().slice(0, 50) }}</b-tag> {{ props.row.filename }}
                  </b-table-column>
                  <!-- <b-table-column cellClass="has-text-right" width="5" field="Records" label="Records" v-slot="props">
                    
                  </b-table-column> -->
                  <b-table-column cellClass="has-text-right" width="5" field="Status" v-slot="props">
                    <b-tag type="is-white">{{props.row.records || 0}} Records</b-tag> 
                    <b-tag type="is-white" v-if="props.row.status == 'complete'">Completed</b-tag> 
                    <b-tag type="is-white" v-else-if="props.row.status == 'running'">In Progress</b-tag> 
                    <b-tag type="is-white" v-else>{{props.row.status ? props.row.status.toUpperCase() : 'Pending'}}</b-tag> 
                </b-table-column>
                  <!-- <b-table-column width="20" field="Data source" label="" v-slot="props">
                    {{ props.row.createdAt.toDate().toLocaleString('en-US', {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: false, // Use 24-hour format
                                    }) }} 
                  </b-table-column> -->
            </b-table>

                    </b-collapse>
           
            
            
            <!-- <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false">
            </b-loading> -->
            
            
            <div :class="(isOnboarding ? 'box' : '') " v-if="rows.length >= getRecordsLimit()">
                <hr>
                <b-notification type="is-warning" :closable="false">
                    <h4 class="title is-5">
                        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>&nbsp;Records per project quota exceeded :/
                    </h4>
                </b-notification>
                <h6 class="title is-5">
                    Please consider upgrading to PRO account for up to 10k records per project
                </h6>

                    
                <p>Your plan support up to {{ getRecordsLimit() }} records per project, you've uploaded {{ rows.length }}.</p>
                <br>
                <p>Feel free to get in touch for tailored solutions: hi@metatext.io</p>
                <br>
                <b-button expanded type="is-primary" tag="router-link" :to="'/d/pricing'">
                            <b>Upgrade</b>
                </b-button>
            </div>
            
            
            <div :class="(isOnboarding ? 'box' : '') " v-else-if="currentUser">
                <div v-if="inputFile" class="buttons is-pulled-right">
                    <b-button type="" size="" @click="cancelUpload()">
                        <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"/></svg> Undo
                    </b-button>
                </div>
                <h4 class="title is-4" v-if="!inputFile && !isOnboarding">
                    
                </h4>

                    <div class="xcolumns is-centered" v-if="!inputFile && !isOnboarding">
                        <div class="xcolumn is-8">
                            <div class="xcolumns is-centered">
                                <div class="xcolumn is-full">
                                    <hr>
                                    <b-field label="Upload" message="Choose the data source to upload your records">
                                    </b-field>
                                    <div class="tile is-ancestor">
                                        <div :class="'tile is-parent'"
                                            v-for="i in ['manual', 'csv', 'pdf', 'api']" :key="i.id">
                                            <a @click="inputTask = i">
                                            <article class="tile is-child boxx">
                                            
                                                <b-image :class="'card setup '+(inputTask == i?'setup-selected':'')" 
                                                        :src="require(`@/images/ai-input-${i}.svg`)"
                                                        style="max-height: 10em; min-width: 5em;">
                                                </b-image>
                                            
                                            
                                            </article>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        </div>
                        <br>
                    </div>


                    <div class="columns is-desktop" v-if="currentUser.plan && ['manual'].includes(inputTask)">
                    <div class="column">
                        <div class="columns">
                        <div class="column is-12">
                        <h4 class="subtitle is-5">
                            Type your data or copy and paste here
                        </h4>
                        <div class="xcontent">
                            <b-field message="">
                            <b-input 
                                ref="add_record"
                                :maxlength="5000"
                                expanded
                                rows="3"
                                required
                                size="is-mediumx"
                                type="textarea" v-model="add_record_text"
                                placeholder="Type your text here">
                            </b-input>
                            </b-field>
                            <b-field>
                                <b-button expanded ref="add_record" @click="addRecord" type="is-primary">Add a record manually</b-button>
                            </b-field>
        </div>
                        

                        

                        </div>
                        </div>
                    </div>
                </div>

                <div class="columns is-desktop" v-if="currentUser.plan && ['api'].includes(inputTask)">
                    <div class="column">
                        <div class="columns">
                        <div class="column is-12">
                        <h4 class="subtitle is-5">
                            Send your data by <b>a HTTP API</b> to create new records with text, optionally, predefined labels.
                        </h4>
                        
                        <div class="contentx">
                            <b-tag size="is-medium" type="is-success">
                                <b>POST</b>
                            </b-tag>
                            <b-tag size="is-large" type="is-white">https://api.metatext.ai/v1/projects/{{ project.id }}/records</b-tag>
                            <br>
                            <b-tag size="is-medium" type="is-light">
                                <b>Payload</b>
                            </b-tag>
                            <b-tag size="is-large" type="is-white" v-if="project.type == 'extraction'">
                                {"text": "This is a Tesla Model Y year 2019", "labels": [{"label": "car model", "text": "Tesla Model Y"}]}
                            </b-tag>
                            <b-tag size="is-large" type="is-white" v-else>
                                {"text": "This restaurant is awesome!", "labels": [{"label": "sentiment_positive"}]}
                            </b-tag>
                            <br>
                            <b-tag size="is-medium" type="is-light">
                                <b>Docs</b>
                            </b-tag>
                            <b-tag size="is-large" type="is-white">
                            <a href="https://metatext.ai/documentation/records-api" target="_blank">API documentation</a>
                            </b-tag>
                            <br>
        </div>
                        

                        

                        </div>
                        </div>
                    </div>
                </div>
                
                <div class="columns is-desktop" v-if="currentUser.plan && ['csv', 'pdf'].includes(inputTask) && !inputFile">
                <div class="column">
                    <div class="columns">
                    <div class="column is-12">
                    <h4 class="subtitle is-5" v-if="inputTask == 'pdf'">

                        Upload an <b>unstructured document</b> that includes text only.

                    </h4>
                    <h4 class="subtitle is-5" v-else>
                        Upload a <b>structured CSV file</b> that includes text and, optionally, the predefined labels.
                        
                    </h4>
                    
                    <b-notification type="is-warning" v-if="(currentUser.plan.datasetRowsLimit) < 1">
                        <p><b>Dataset Rows Limit Reached</b></p>
                        <p>Your total used rows: {{ currentUser.datasetRowsTotal }}</p>
                        <p>To upload more data, consider upgrading to a paid plan.</p>
                        <p>If you need additional resources, don't hesitate to contact us for customized solutions.</p>
                    </b-notification>
                    
                    <b-field >
                        
                        <b-upload 
                        v-model="inputFile"
                        @input="changeInput"
                        drag-drop 
                        expanded
                        required
                        :disabled="(project.public && project.userId != currentUser.userId) || (currentUser.plan.datasetRowsLimit) < 1">
                            <section class="content">
                            <div class="x has-text-centered" v-if="!inputFile">
                                <b-icon icon="upload" size="is-large"></b-icon>
                                <p>Drop a structured file text here or click to upload</p>
                                <p v-if="inputTask == 'pdf'">Support .PDF, .DOCX, .HTML, .TXT file types</p>
                                <p v-else>Support .CSV file type</p>
                            </div>
                            <div class="content has-text-centered" v-else>
                                <div class="subtitle is-4">
                                    {{ inputFile.name }} 
                                </div>
                                <span v-if="(inputFile.size/1024/1024) < 1000.00">
                                    Size: {{ (inputFile.size/1024/1024).toFixed(2) }} MB
                                </span>
                                <span v-else>
                                    Size: {{ (inputFile.size/1024/1024/1024).toFixed(2) }} GB
                                </span>
                            </div>
                            </section>
                        </b-upload>
                        
                    </b-field>

                    <small>
                            <a target="blank" href="https://docs.google.com/spreadsheets/d/1RFZOy25pPsA9oZSAXDIe22aVVkOxIuTES2w4PKlYbtA/edit?usp=sharing"><svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"> <path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/></svg> 
                            Download an CSV example
                            </a>
                        </small>
                </div>
                </div>
                </div>
                </div>
                
                <br>
                <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="true">
                    <h4 class="title is-4">Processing your dataset...</h4>
                </b-loading>

                <section class="" v-if="set_text_column">

                    <h4 class="title is-4">Specify the text column</h4>
                        <h4 class="subtitle is-5">
                            Choose the column that contains the text data.
                        </h4>
                    <div class="columns">
                        <div class="column table-container is-scrollable">
                        <table class="table is-striped" v-if="parsed" style="width: 100%;">
                            
                            <thead>
                                <tr>
                                    <th v-for="(header, key) in fields"
                                        v-bind:key="'header-'+key">
                                        <b-button @click="setTextColumn(header, key)" class="is-info" size="is-medium" outlined expanded>
                                            {{ map_number_to_letter[key] +": "+ header }}
                                        </b-button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, rowKey) in content.data"
                                    v-bind:key="'row-'+rowKey">
                                        <td v-for="(column, columnKey) in fields"
                                            v-bind:key="'row-'+rowKey+'-column-'+columnKey">
                                                <span v-if="content.data[rowKey][column].length > 50">
                                                    {{ content.data[rowKey][column].substring(0, 50) }}...
                                                </span>
                                                <span v-else>
                                                    {{ content.data[rowKey][column] }}
                                                </span>
                                                
                                        </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                </section>
                <section class="" v-if="set_label_column">
                    <h4 class="title is-4">
                        Awesome! All set for upload
                    </h4>
                        <h4 class="subtitle is-5">
                            (If applicable) Choose the column that contains the label data.
                        </h4>
                        
                    <div class="columns">
                        <div class="column table-container">
                        <table class="table is-striped" v-if="parsed" style="width: 100%;">
                            
                            <thead>
                                <tr>
                                    <th v-for="(header, key) in fields"
                                        v-bind:key="'header-'+key">
                                        <b-button v-if="text_column_key == key" class="is-info" size="is-medium" outlined expanded disabled>
                                            Text
                                        </b-button>
                                        <b-button v-else @click="setLabelColumn(header, key)" class="is-info" size="is-medium" outlined expanded :disabled="block">
                                            {{ map_number_to_letter[key] +": "+ header }}
                                        </b-button>
                                        
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, rowKey) in content.data"
                                    v-bind:key="'row-'+rowKey">
                                        <td v-for="(column, columnKey) in fields"
                                            v-bind:key="'row-'+rowKey+'-column-'+columnKey">
                                                <span v-if="content.data[rowKey][column].length > 50">
                                                    {{ content.data[rowKey][column].substring(0, 50) }}...
                                                </span>
                                                <span v-else>
                                                    {{ content.data[rowKey][column] }}
                                                </span>
                                        </td>
                                </tr>
                            </tbody>
                        </table>
                        <br>
                        <b-button class="fixed-button is-info" :disabled="block" @click="uploadFile()" size="is-medium" expanded>
                            Upload
                        </b-button>
                        <br><br>
                        </div>
                    </div>
                </section>

                <section class="" v-if="ready_to_import">
                    <h4 class="title is-4">
                        {{ ready_to_import_text }}
                    </h4>
                    <h4 class="subtitle is-5">
                        Your dataset is prepared for processing, and an AI model will assist you in annotating it.
                    </h4>
                    <div class="columns">
                        <div class="column table-container">
                        <table class="table is-striped" v-if="parsed" style="width: 100%;">
                            
                            <thead>
                                <tr>
                                    <th v-for="(header, key) in fields"
                                        v-bind:key="'header-'+key">
                                        <b-button v-if="text_column_key == key" class="is-info" size="is-medium" expanded disabled>
                                            Text
                                        </b-button>
                                        <b-button v-else-if="label_column_key == key" class="is-info" size="is-medium" expanded disabled>
                                            Label
                                        </b-button>
                                        <b-button v-else class="is-info" size="is-medium" outlined expanded disabled>
                                            {{ map_number_to_letter[key] +": "+ header }}
                                        </b-button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, rowKey) in content.data"
                                    v-bind:key="'row-'+rowKey">
                                        <td v-for="(column, columnKey) in fields"
                                            v-bind:key="'row-'+rowKey+'-column-'+columnKey">
                                                <span v-if="content.data[rowKey][column].length > 50">
                                                    {{ content.data[rowKey][column].substring(0, 50) }}...
                                                </span>
                                                <span v-else>
                                                    {{ content.data[rowKey][column] }}
                                                </span>
                                        </td>
                                </tr>
                            </tbody>
                        </table>
                        <br>
                        <b-button class="fixed-button  is-info" :disabled="block" @click="uploadFile()"  size="is-medium" expanded>
                            Upload 
                        </b-button>
                        </div>
                    </div>
                    
                </section>

                <section class="" v-if="set_extra_fileformat">
                    <h4 class="title is-4">
                        Upload {{  inputFile.type }} file
                    </h4>
                    <p class="subtitle is-5">
                        {{  inputFile.name }}<br>
                        No preview available<br>
                        <span v-if="(inputFile.size/1024/1024) < 1000.00">
                            Size: {{ (inputFile.size/1024/1024).toFixed(2) }} MB
                        </span>
                        <span v-else>
                            Size: {{ (inputFile.size/1024/1024/1024).toFixed(2) }} GB
                        </span>
                    </p>
                    <b-field label="Select a split option">
                        <b-select 
                          v-model="selectedSplitOption" 
                          placeholder="Select a split option"
                        >
                            <option
                                v-for="options in split_data"
                                :value="options.id"
                                :key="options.id">
                                {{ options.split.split_option }}
                            </option>
                        </b-select>
                    </b-field>
                    <p class="subtitle is-5">
                        Your file {{  inputFile.name }} will be uploaded and processed. If you have specific needs please contact us help@metatext.io
                    </p>                
                    <h4 class="subtitle is-5">
                        Upload may take a few minutes.
                    </h4>
                    <div class="columns">
                        <div class="column table-container">
                            
                        <b-button class="fixed-button  is-info" :disabled="block" @click="uploadFile()" size="is-medium" expanded>
                            Upload 
                        </b-button>
                        </div>
                    </div>
                    
                </section>
                
                
            </div>
            <span v-if="isOnboarding">
                <br><br><br><br><br><br><br>
            </span>
            
            <!-- <div class="box" v-if="!isOnboarding">
                <h4 class="title is-4">Uploaded datasets</h4>
                
                
                <h4 class="title is-6 is-size-6" v-for="dataset in projectDatasets" v-if="dataset.filename">
                    📄&nbsp;{{ (dataset.createdAt)?dataset.createdAt.toDate().toDateString():'' }} 
                    
                    | File: 
                    <a :href="'/datasets/'+dataset.datasetId+'/analysis'" target="_blank">
                    {{ dataset.filename + `\t`}}{{ dataset.uploadId }}
                    </a>
                </h4>
                <h4 class="title is-6 is-size-6" v-else>
                    No uploads yet
                </h4>
                <b-skeleton size="is-large" :active="!projectDatasets"></b-skeleton>
                
            </div> -->
            
            
        </div>
        
    </section>


    <b-modal
          v-model="isModalLabelsOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="false"
          aria-role="dialog"
          aria-label="Model"
          aria-modal
          scroll="keep">
          <template #default="props">
            <ModalLabels @close="props.close" :project="project" :projectDocuments="projectDocuments"></ModalLabels>
          </template>
      </b-modal>

    </div>


    
    
</template>
<script>
// import ModalDataset from '@/components/DatasetIncrease.vue'
// import ModalModel from '@/components/ModelCreateNew.vue'
import ModalLabels from '@/components/ModalLabels.vue'
import Papa from 'papaparse';
import firebase from 'firebase/compat/app';
import { mapState } from 'vuex';

   export default {
     props: {
        isOnboarding: {
            type: Boolean,
            default() {
                return false
            }
        },
        inputTask: {
            type: String,
            default() {
                return 'csv'
            }
        },
        project: Object,
        currentUser: Object,
        filterId: String,
     },
     name: "Uploads",
     data: function() {
    return {
        uploads: [],
        inputFile: null,
        data: null,
        split_data : [ {"id":1,"split":{"split_option":"sentence"}},
                       {"id":2,"split":{"split_option":"paragraph"}},
                       {"id":3,"split":{"split_option":"page"}}],
        splitOptions: null,
        uploadPayload: null,
        options: null,
        content: null,
        parsed: false,
        header: true,
        set_text_column: false,
        set_label_column: false,
        set_extra_fileformat: false,
        ready_to_import: false,
        text_column_name: null,
        text_column_key: null,
        label_column_name: null,
        label_column_key: null,
        datasetIds: [],
        isLoading: false,
        isComplete: false,
        isModalLabelsOpen: false,
        block: false,
        ready_to_import_text: "Excelent! All set to upload",
        unique_labels: [],
        labels: [],
        datasetId: null,
        uploadId: null,
        delimiter: null,
        selectedSplitOption: null,
        map_number_to_letter: {},
        add_record_text: null,
        row: {
            text: null,
            label: null
        },
        showFileUpload: false
    }},
    components: {
    //   ModalDataset,
    //   ModalModel,
      ModalLabels
    },
    computed: mapState([
        'projectUploads', 'rows'
     ]),
     watch: {
        rows: {
            handler() {
                // Example: Call a method when rows change
                // this.refreshUploadFile();
            },
            deep: true, // Watch nested properties inside 'rows'
            immediate: true // Trigger the handler immediately on component mount
        }
     },
     methods: {
        getRecordsLimit(){
            let hasDatasetRowsLimit = Object.hasOwn(this.currentUser, 'plan') ? Object.hasOwn(this.currentUser.plan, 'datasetRowsLimit') : false
            let recordsLimit = hasDatasetRowsLimit ? this.currentUser.plan.datasetRowsLimit : 1000
            return  recordsLimit
        },
        getApiKey(){
            if ("apiKey" in this.currentUser){
                return this.currentUser.apiKey
            } else {
                return "your-api-key"
            }
        },
        generateMapNumberToLetter(size) {
            const map = {};
            const startCode = 'A'.charCodeAt(0);
            for (let i = 0; i < size; i++) {
                map[i] = String.fromCharCode(startCode + i);
            }
            return map;
        },
        cancelUpload(){
            this.inputFile = null
            this.set_text_column = null
            this.set_label_column = null
            this.ready_to_import = null
            this.set_extra_fileformat = null
        },
        createRow(){
            this.$store.dispatch('createRow', this.row)
        },
        changeInput() {

            console.log(this.inputFile)

            // Only process csv files.
            if (this.inputFile.name.match(/\.(csv)$/)) {
                this.parseFile(this.inputFile);
                this.set_text_column = true
                this.set_extra_fileformat = false
                
            } else {
                this.set_extra_fileformat = true
                return;
            }
            
        },
        setTextColumn(h, k){
            console.log(h,k)
            this.text_column_name = h
            this.text_column_key = k
            this.set_text_column = false
            this.set_label_column = true
        },
        setLabelColumn(h, k){
            console.log(h,k)
            this.label_column_name = h
            this.label_column_key = k
            this.set_label_column = false
            this.ready_to_import = true
        },
        parseToJson(dataFile){
            console.log(dataFile)
            Papa.parse(dataFile, {
                header: true
                // complete: function(results) {
                //     callback(results.data, dataFile.name);
                // }
            })
        },
        parseFile(file){
            Papa.parse( file, {
                header: this.header,
                skipEmptyLines: true,
                preview: 6,
                complete: function( results ){
                    console.log(results)
                    this.content = results;
                    this.parsed = true;
                    
                    this.fields = results.meta.fields    
                    this.delimiter = results.meta.delimiter

                }.bind(this)
            });

            
        },
        // callback(){
        //     console.log(this.text_column_key, this.text_column_name)
        //     console.log(
        //         "Row -> text: "+ this.row.data[1]
        //     )
        // },
        onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        },
        parseComplete(labels){
            console.log(labels)
        },
        uploadFile(){
            const datasetId = this.datasetId || this.project.datasetId

            this.block = true
            if(this.isOnboarding == true){
                this.block = true
            }

            this.$buefy.toast.open('Uploading file '+this.inputFile.name+'...')
            // datasetId exists?
            
            if (!datasetId){
                
                const dataset = {
                    "projectId": this.project.id
                }

                var newDataset = this.$store.dispatch("createDataset",
                    dataset
                )

                newDataset.then(datasetId => {
                    //emit isDatasetId
                    this.project.datasetId = datasetId
                    this.datasetId = datasetId
                    this.$emit("datasetId", datasetId)
                    this.addDatasetUploads(datasetId)
                })

            } else {
                this.addDatasetUploads(datasetId)
            }

            
        },
        addDatasetUploads(datasetId){

                const fileFormat = this.inputFile.name.split('.').pop()

                const datasetUpload = {
                    datasetId: datasetId,
                    filename: this.inputFile.name,
                    fileFormat: fileFormat,
                    projectId: this.project.id,
                    textColumnKey: this.text_column_key,
                    textColumnName: this.text_column_name,
                    labelColumnKey: this.label_column_key,
                    labelColumnName: this.label_column_name,
                    delimiter: this.delimiter
                }

                console.log(datasetUpload)

                var newDoc = this.$store.dispatch("increaseDataset",
                    datasetUpload
                )

                const addDatasetToProject = {
                    projectId: this.project.id,
                    update: {
                        datasetId: datasetId
                    }
                }
                
                this.$store.dispatch("addDatasetToProject",
                    addDatasetToProject
                )

                newDoc.then(uploadId => {
                    this.datasetId = datasetId
                    this.uploadId = uploadId
                    this.isLoading = true
                    const filepath = `datasets/${datasetId}/files/${uploadId}/${this.inputFile.name}`;

                    firebase.storage().ref(filepath).put(this.inputFile).then(
                        this.completeConfirm
                    )
                })
        },
        completeConfirm(){
            this.isLoading = true
            // let that = this
            let labels = this.labels.filter(this.onlyUnique).filter( i => i != undefined && i != '')
            let splitOption = null
            if (this.selectedSplitOption != undefined){
                splitOption = this.split_data.find(item => item.id === this.selectedSplitOption).split.split_option
            }
            this.$emit("labels", labels)
            this.$emit("isComplete", true)
            
            this.$store.dispatch("updateUploadDataset",
                {datasetId: this.datasetId, uploadId: this.uploadId, update: {labels: labels, splitOption: splitOption}}
            )

            this.wait() 
            
            
        },
        wait(){
            this.isLoading = true
            setTimeout(() => 
                this.showFileUpload = true,
            5000)
            setTimeout(() => 
                this.isLoading = false,
            5000)
          
          this.showFileUpload = true
          let uploadPayload = {datasetId: this.datasetId, uploadId: this.uploadId, taskType: this.project.type}
          this.$store.dispatch( "datasetAnalysis", uploadPayload ).then( (res) => {
                this.$store.dispatch("projectUploads", this.project.datasetId).then( () => {
                    this.$store.dispatch('getRowsByDataset', this.project.datasetId).then( () => {
                        this.refreshUploadFile()
                    })
                })
                console.log(res.status)
                let status = res.status
                let lines = res.lines
                let records = res.records
                let duplicates = res.duplicates
                let message = res.message
                let remaining_records = res.remaining_records

                let status_capitalized = status.charAt(0).toUpperCase() + status.slice(1);
                let output = `<b><b>${status_capitalized}!</b></b>`
                if (message){
                    output += `<br>${message}<br>`
                }
                output += `<br><b>Upload records summary:</b>`
                if (lines > 0){
                    output += `<br>Found ${lines}`
                }

                output += `<br>Added ${records}`
                
                if (duplicates > 0){
                    output += `<br>Ignored ${duplicates} duplicates`
                }

                if (remaining_records){
                    output += `<br>Records quota for this project ${remaining_records}`
                }
                
                this.$buefy.dialog.confirm({
                        message: output,
                        canCancel: false,
                        onConfirm: () => this.finish(status) 
                })
            })
        },
        finish(status){

            
            this.block = false
            this.inputFile = null
            this.data = null
            this.content = null
            this.parsed = false
            this.header = true
            this.set_text_column = false
            this.set_label_column = false
            this.ready_to_import = false
            this.set_extra_fileformat = false

            this.isLoading = false
            if (this.isOnboarding === true){
                this.isComplete = true
                this.ready_to_import_text = `${status}. All set to upload`
                return;
            }
            setTimeout(() => 
                //this.openLoading(), 
            1)

        },
        addRecord(){
            let isFullPage = false
            this.isGenerate = true
            const loadingComponent = this.$buefy.loading.open({
                container: isFullPage ? null : this.$refs.add_record.$el
            })
            this.$store.dispatch(
                "addRecord",
                {text: this.add_record_text, fields: [], labels: [], tags: [], projectId: this.project.id}
            ).then( (res) => {
                this.isGenerate = false
                console.log(res)
                
                loadingComponent.close()

                this.$emit("datasetId", res.dataset_id)
                this.$emit("isComplete", true)

                this.$buefy.snackbar.open({
                    duration: 1000,
                    queue: true,
                    message: `<b>Added to dataset</b><br>Text: <em>${this.add_record_text.slice(0, 30)}...</em>.`,
                    type: "is-white",
                    position: "is-bottom-left",
                    pauseOnHover: true
                });
                this.add_record_text = ''

                this.refreshUploadFile()
                
            })
        },
        refreshUploadFile(){
            this.$store.dispatch('getRowsByDataset', this.project.datasetId)

            const uploadAPICount = this.rows.filter( r => r.uploadId == 'API').length
            const apiUploadIndex = this.projectUploads.find(upload => upload.id === 'API');

            if (uploadAPICount > 0){
                if (apiUploadIndex == -1){
                    this.projectUploads.push({id: 'API', records: uploadAPICount, filename: 'API', fileFormat: 'API', status: 'complete'})
                } else {
                    this.projectUploads[apiUploadIndex] = {id: 'API', records: uploadAPICount, filename: 'API', fileFormat: 'API', status: 'complete'}
                }
            }

            
        }
     },
     mounted() {
        this.$store.dispatch("projectUploads", this.project.datasetId).then( () => {
            this.$store.dispatch('getRowsByDataset', this.project.datasetId).then( () => {
                this.refreshUploadFile()
            })
        })

        this.map_number_to_letter = this.generateMapNumberToLetter(26)
     }
   };
</script>

<style lang="scss" scoped>

.fixed-buttonx {
    position: fixed;
    bottom: 5.6em;
    max-width: 60em;
    min-width: 60em;
}

.is-scrollable {
      overflow-x: scroll;
}
th, td { min-width: 5px; max-height: 5px; }

.boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 16px;

  .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;

    &:hover {
      background: #fafafa;
    }

    .info {
      padding: 16px;

      .name {
        display: block;
        margin-bottom: 8px;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 0;
        margin-bottom: 8px;
        overflow: hidden;
      }
    }
  }
}



.setup-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 2fr));
    gap: 3em;
  
    .setup-selected {
          border: dashed 3px #bdbdbd !important;
      }
  
    .setup {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
      
  
      &:hover {
        background: #fafafa;
        border: dashed 1px #bdbdbd;
      }
  
      &:active {
          border: dashed 2px #bdbdbd;
      }
  
      &:checked {
          border: dashed 2px #bdbdbd;
      }
      
  
      .info {
        padding: 16px;
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }
      }
    }
  }
  
  .setup-center {
    margin: auto;
    width: 90%;
  }

/* Python code style */

code.language-python {
  word-wrap: break-word;
}

code.language-python span.token.punctuation {
  color: #999;
}

code.language-python span.token.keyword {
  color: #0074D9;
}

code.language-python span.token.operator {
  color: #111;
}

code.language-python span.token.string {
  color: #2ECC40;
}

code.language-python span.token.comment {
  color: #888;
  font-style: italic;
}

code.language-python span.token.function {
  color: #FF4136;
}
</style>
